window.addEventListener('DOMContentLoaded', () => {

  //アカウント画面
  if (window.location.pathname === '/account/register') {
    saRegistLinkOnClick();
  }

  //ログイン画面
  if (window.location.pathname === '/account/login') {
    saLoginLinkOnClick();
    saRegisterButtonOnLoginPage();
  }

  //認証ダミー画面
  if (window.location.pathname === '/pages/authreq') {
    saLinkAuthRequest();
  }

  //退会確認画面
  if (window.location.pathname === '/pages/account-leave-confirm') {
    saLinkConfirmDeleteAccount();
    saLinkReturnToMyPage();
  }

  //退会完了画面 or カスタムエラー画面 or メールアドレス重複エラー画面
  if (window.location.pathname === '/pages/account-leave-complete' || window.location.pathname === '/pages/error' || window.location.pathname === '/pages/duplicate-email-error') {
    saLinkReturnToTopPage();
  }

  //マイページ住所画面
  if (window.location.pathname === '/account/addresses') {
    saLinkAddress();
  }

});

/**
ログイン後遷移先URL取得処理
**/
function getReturnToUrl()  {

    console.log('****** now url search : ', window.location.search)
    const urlParams = new URLSearchParams(window.location.search);
    const checkoutUrl = urlParams.get('checkout_url') ? urlParams.get('checkout_url') : '';
    console.log('****** checkoutUrl : ', checkoutUrl);

    const checkStoreDomain = window.location.origin;
    console.log('****** checkStoreDomain : ', checkStoreDomain);
    if (checkoutUrl !== '') {
        if (checkoutUrl.startsWith(checkStoreDomain)) {
            const encodeOrgCheckoutUrl = encodeURI(checkoutUrl);
            console.log('****** getReturnToUrl return org checkout url : ', encodeOrgCheckoutUrl);
            return encodeOrgCheckoutUrl;
        } else {
            const retCheckoutUrlObj = new URL(checkStoreDomain + checkoutUrl);
            const encodeCheckoutUrl = encodeURI(retCheckoutUrlObj.toString());
            console.log('****** getReturnToUrl return edit checkout url : ', encodeCheckoutUrl);
            return encodeCheckoutUrl;
        }
    } else {
        console.log('****** getReturnToUrl return no checkout url : ', saLinkReturnTo);
        return saLinkReturnTo;
    }
}

/**
アカウント登録ボタン
**/
function saRegistLinkOnClick() {

  const saLinkButton = document.querySelector('.sa-link-button');

  if (saLinkButton === null) {
    return;
  }

  saLinkButton.addEventListener('click', async () => {

    saLinkNowLoading();

    const response = await saLinkFetchApi(SA_APP_PROXY_AUTHPARAM,'GET','');

    if (typeof response.client_id === 'undefined' || response.client_id === null || response.client_id === ''
        || typeof response.scope === 'undefined' || response.scope === null || response.scope === ''
        || typeof response.nonce === 'undefined' || response.nonce === null || response.nonce === ''
        || typeof response.state === 'undefined' || response.state === null || response.state === '') {
      saLinkRedirectToErrorPage();
    } else {
      saLinkSetItem(SA_SESSIONSTORAGE_REDIRECT_URI,SA_REDIRECT_URI);
      saLinkSetItem(SA_SESSIONSTORAGE_RETURN_TO,getReturnToUrl());
      saLinkSetItem(SA_SESSIONSTORAGE_STATE,response.state);
      saLinkSetItem(SA_SESSIONSTORAGE_NONCE,response.nonce);

      const saLinkUrl = `${SA_SUNTORY_CONNECT_AUTH}?response_type=code&client_id=${response.client_id}&redirect_uri=${encodeURIComponent(SA_REDIRECT_URI)}&scope=${response.scope}&nonce=${response.nonce}&state=${response.state}&prompt=create`;

      saLinkRemoveLoading();
      
      window.location.href = saLinkUrl;
    }
  });

}

/**
ログインボタン
**/
function saLoginLinkOnClick() {

  const saLinkButton = document.querySelector('.sa-link-button');

  if (saLinkButton === null) {
    return;
  }

  saLinkButton.addEventListener('click', async () => {

    saLinkNowLoading();

    const response = await saLinkFetchApi(SA_APP_PROXY_AUTHPARAM,'GET','');

    if (typeof response.client_id === 'undefined' || response.client_id === null || response.client_id === ''
        || typeof response.scope === 'undefined' || response.scope === null || response.scope === ''
        || typeof response.nonce === 'undefined' || response.nonce === null || response.nonce === ''
        || typeof response.state === 'undefined' || response.state === null || response.state === '') {
      saLinkRedirectToErrorPage();
    } else {
      saLinkSetItem(SA_SESSIONSTORAGE_REDIRECT_URI,SA_REDIRECT_URI);
      saLinkSetItem(SA_SESSIONSTORAGE_RETURN_TO,getReturnToUrl());
      saLinkSetItem(SA_SESSIONSTORAGE_STATE,response.state);
      saLinkSetItem(SA_SESSIONSTORAGE_NONCE,response.nonce);

      const saLinkUrl = `${SA_SUNTORY_CONNECT_AUTH}?response_type=code&client_id=${response.client_id}&redirect_uri=${encodeURIComponent(SA_REDIRECT_URI)}&scope=${response.scope}&nonce=${response.nonce}&state=${response.state}`;

      saLinkRemoveLoading();
      
      window.location.href = saLinkUrl;
    }
  });

}

function saLinkFetchApi(url,method,body) {
  let options = {};
  if (body !== '') {
    options = {
      method: method,
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    }
  } else {
    options = {
      method: method
    };
  }
  return fetch(url,options)
   .then(response => {
      if (response.status == 409) {
        return {'redirect_url': '/pages/duplicate-email-error'};
      } else if (!response.ok) {
        throw new Error("システムエラー発生");
      }
     return response.json();
   })
   .catch(error => {
     saLinkRedirectToErrorPage();
   });
}

function saLinkGetItem(key) {
  try {
    return sessionStorage.getItem(key);
  } catch {
    saLinkRedirectToErrorPage();
  }
}

function saLinkSetItem(key,value) {
  try {
    sessionStorage.setItem(key,value);
  } catch {
    saLinkRedirectToErrorPage();
  }
}

function saLinkRemoveItem(key) {
  try {
    sessionStorage.removeItem(key);
  } catch {
    saLinkRedirectToErrorPage();
  }
}


/**
ログインボタン/アカウント登録 ダミー画面
**/
async function saLinkAuthRequest() {
  const urlParams = new URLSearchParams(window.location.search);
  const params = {
    code: urlParams.get('code') ? urlParams.get('code') : '',
    state: urlParams.get('state') ? urlParams.get('state') : ''
  }

  const sStorage = {
    nonce: saLinkGetItem(SA_SESSIONSTORAGE_NONCE) ? saLinkGetItem(SA_SESSIONSTORAGE_NONCE) : '',
    state: saLinkGetItem(SA_SESSIONSTORAGE_STATE) ? saLinkGetItem(SA_SESSIONSTORAGE_STATE) : '',
    redirect_uri: saLinkGetItem(SA_SESSIONSTORAGE_REDIRECT_URI) ? saLinkGetItem(SA_SESSIONSTORAGE_REDIRECT_URI) : '',
    return_to: saLinkGetItem(SA_SESSIONSTORAGE_RETURN_TO) ? saLinkGetItem(SA_SESSIONSTORAGE_RETURN_TO) : ''
  };

  saLinkRemoveItem(SA_SESSIONSTORAGE_REDIRECT_URI);
  saLinkRemoveItem(SA_SESSIONSTORAGE_RETURN_TO);
  saLinkRemoveItem(SA_SESSIONSTORAGE_STATE);
  saLinkRemoveItem(SA_SESSIONSTORAGE_NONCE);

  if (params.state !== '' && sStorage.state !== '' && params.state === sStorage.state) {
    const reqBody = {
      code: params.code,
      redirect_uri: sStorage.redirect_uri,
      return_to: sStorage.return_to,
      nonce: sStorage.nonce
    }

    const response = await saLinkFetchApi(SA_APP_PROXY_REGISTLOGIN,'POST',reqBody);

	if (typeof response === 'undefined') {
      saLinkRedirectToErrorPage();
    }

    if (typeof response.redirect_url !== 'undefined' && response.redirect_url !== null && response.redirect_url !== '') {
       window.location.href = response.redirect_url;
    } else {
      saLinkRedirectToErrorPage();
    }
  } else {
    saLinkRedirectToErrorPage();
  }
}

/**
退会確認画面
**/
function saLinkConfirmDeleteAccount() {
  const confirmDeleteButton = document.querySelector('.withdrawal-confirm-button');

  if (confirmDeleteButton === null) {
    return;
  }

  confirmDeleteButton.addEventListener('click', async () => {

	saLinkNowLoading();

    const withdrawalReq = (url) => {
      fetch(url,{method:'POST'})
      .then(response => {
        if (!response.ok) {
          throw new Error("システムエラー発生");
        }

        saLinkLogout();
      })
      .catch(error => {
		saLinkRemoveLoading();
        saLinkRedirectToErrorPage();
      })
    }

    await withdrawalReq(SA_APP_PROXY_WITHDRAWAL);

  });
}

function saLinkNowLoading(){
  if(document.querySelector('#sa-link-loading') == null){
    const div = document.createElement('div');
    div.setAttribute('id','sa-link-loading');
    document.body.append(div);
  }
}

function saLinkRemoveLoading(){
  document.querySelector('#sa-link-loading').remove();
}

function saLinkLogout() {
  fetch('/account/logout')
  .then(response => {
    window.location.href = '/pages/account-leave-complete'
  })
}

function saLinkReturnToMyPage() {
  const myPageButton = document.querySelector('.sa-link-mypage-button');

  if (myPageButton === null) {
    return;
  }

  myPageButton.addEventListener('click',() => {
    window.location.href = '/account';
  });
}

/**
退会完了画面、システムエラー画面 Topページ遷移ボタン
**/
function saLinkReturnToTopPage() {
  const topButton = document.querySelector('.sa-link-top-button');

  if (topButton === null) {
    return;
  }

  topButton.addEventListener('click',() => {
    window.location.href = '/';
  });
}

/**
SA住所表示
**/
function saLinkAddress() {

  const addressList = document.querySelectorAll('[data-address-id]');

  if (addressList === null) {
    return;
  }

  if (addressList.length !== 0) {
    const saLinkAddressId = SA_ADDRESS_ID.replace('gid://shopify/MailingAddress/','').replace(/\?.*$/,'');
    for (const address of addressList) {
      if (address.dataset.addressId === saLinkAddressId) {
        address.parentNode.remove();
        break;
      }
    }
  }
}

/**
システムエラー画面遷移
**/
function saLinkRedirectToErrorPage() {
  window.location.href = '/pages/error';
}
/**
ログインページの会員登録ボタン
**/
function saRegisterButtonOnLoginPage() {
  const saRegisterButton = document.querySelector('.sa-register-link-button');

  if (saRegisterButton === null) {
    return;
  }

  saRegisterButton.addEventListener('click', async () => {

    saLinkNowLoading();

    const response = await saLinkFetchApi(SA_APP_PROXY_AUTHPARAM,'GET','');

    if (typeof response.client_id === 'undefined' || response.client_id === null || response.client_id === ''
        || typeof response.scope === 'undefined' || response.scope === null || response.scope === ''
        || typeof response.nonce === 'undefined' || response.nonce === null || response.nonce === ''
        || typeof response.state === 'undefined' || response.state === null || response.state === '') {
      saLinkRedirectToErrorPage();
    } else {
      saLinkSetItem(SA_SESSIONSTORAGE_REDIRECT_URI,SA_REDIRECT_URI);
      saLinkSetItem(SA_SESSIONSTORAGE_RETURN_TO,getReturnToUrl());
      saLinkSetItem(SA_SESSIONSTORAGE_STATE,response.state);
      saLinkSetItem(SA_SESSIONSTORAGE_NONCE,response.nonce);

      const saLinkUrl = `${SA_SUNTORY_CONNECT_AUTH}?response_type=code&client_id=${response.client_id}&redirect_uri=${encodeURIComponent(SA_REDIRECT_URI)}&scope=${response.scope}&nonce=${response.nonce}&state=${response.state}&prompt=create`;

      saLinkRemoveLoading();
      
      window.location.href = saLinkUrl;
    }
  });
}